<template>
    <v-card ref="container" v-resize="setHeight">
        <iframe
            frameborder="0"
            width="100%"
            :height="height"
            :src="video.stream"
            allowfullscreen></iframe>
        <v-card-text>
            {{ video.title }}
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: 'jazz-video',
    props: {
        video: { type: Object, required: true }
    },

    data: () => ({
        height: 200
    }),

    methods: {
        setHeight() {
            const width = this.$refs.container.$el.offsetWidth
            this.height = width / 16 * 9
        }
    }
}
</script>
